export default __webpack_public_path__ + "static/media/about.d60feb77.png";